import { useState } from "react"
import "../../../assets/scss/forgot-password.scss"
import { supabaseClient } from "../../../utils/supabase"
import { useTheme } from "../../../contexts/ThemeContext"
import getThemeColors from "../../../utils/getColorTheme"

export default function ForgotPassword({ onClickCancel }) {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { addTheme } = useTheme()
  const { theme, background } = getThemeColors(addTheme)

  const apiUrl = process.env.REACT_APP_API_URL 
  
  const sendLink = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
        const res = await fetch(`${apiUrl}/api/auth/send-reset-link`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        const data = await res.json();

        if (res.ok) {
          setMessage("Reset link sent to your email.");
        } else {
          setMessage(data.error || "Error sending reset link.");
        }
    } catch (err) {
      console.error("Reset link error:", err);
      setMessage(err.message || "Something went wrong.");
    }

    setIsLoading(false);
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-content">
        <form onSubmit={sendLink} className="forgot-password-form">
          <div className="input-group">
            <div className="group">
              <label htmlFor="email" style={{ color: theme }}>Email *</label>
              <input
                type="email"
                id="email"
                className="form-control"
                value={email}
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                style={{ background: "transparent", color: theme }}
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="reset-button" 
            disabled={isLoading}
            aria-label="Send password reset link to your email"
          >
            {isLoading ? "Sending..." : "Reset Password"}
          </button>

          {message && <p className="message" aria-live="polite" style={{ color: theme }}>{message}</p>}

          <button 
            type="button" 
            className="back-link" 
            onClick={onClickCancel}
            aria-label="Return to login page"
            style={{ color: theme }}
          >
            Back to Login
          </button>
        </form>
      </div>
    </div>
  )
}
